import React, { Component } from "react";
import { connect } from "react-redux";

import "./styles.scss";
import { Spin, Tabs } from "antd";
import { v4 as uuidv4 } from "uuid";
import { ActionButton, Button, Input, PageHeader } from "../../components";
import SiteMap from "./siteMap";
import moment from "moment";
import { getBank, getCategory, getMerchant } from "../../api";

const { TabPane } = Tabs;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewPointWidth: 0,
      viewPointHeight: 0,
      isActiveShadow: false,
      isLoading: false,
      isLoadingMerchant: false,
      isBankLoading: false,
      isMerchantLoading: false,
      merchantId: "",
      dataSource: [],
      activeMerchant: null,
      merchantData: [],
      tabName: "Merchant mapping",
      selectBank: "1",
      bankIdsList: [],
      merchantIdsList: [],
      tabJson: [
        {
          id: uuidv4(),
          key: 1,
          tabName: "Site Map",
          content: <SiteMap />,
        },
      ],
      dataForm: {
        endDate: {
          key: "endDate",
          elementType: "datePicker",
          elementConfig: {
            label: "End Date",
            size: "md",
            width: "100%",
            placeholder: "DD-MM-YYYY",
          },
          value: "",
          dateValue: "",
          validation: {
            required: true,
          },
          valid: false,
          touched: false,
          label: "End date",
        },
        startDate: {
          key: "startDate",
          elementType: "datePicker",
          elementConfig: {
            label: "End Date",
            size: "md",
            width: "100%",
            placeholder: "DD-MM-YYYY",
          },
          value: "",
          dateValue: "",
          validation: {
            required: true,
          },
          valid: false,
          touched: false,
          label: "Start date",
        },
        keywords: {
          key: "keywords",
          elementType: "select",
          elementConfig: {
            type: "select",
            placeholder: "Select merchant",
            options: [],
            disabled: false,
          },
          value: "",
          validation: {
            required: false,
          },
          valid: false,
          touched: false,
          label: "Merchant",
        },
        bank: {
          key: "bank",
          elementType: "select",
          elementConfig: {
            type: "select",
            placeholder: "Select bank",
            options: [],
            disabled: false,
          },
          value: "",
          defaultValue: "",
          validation: {
            required: true,
          },
          valid: false,
          touched: false,
          label: "Bank",
        },
      },
      newMerchantList: [],
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  updateWindowDimensions() {
    this.setState({
      viewPointWidth: window.innerWidth,
      viewPointHeight: window.innerHeight,
    });
    //window.removeEventListener('scroll', this.handleOnScroll);
  }

  async componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    window.addEventListener("scroll", this.handleOnScroll);
    await this.setAllData();
  }

  handleOnScroll = () => {
    let scrollTop =
      (document.documentElement && document.documentElement.scrollTop) ||
      document.body.scrollTop;
    let scrollHeight =
      (document.documentElement && document.documentElement.scrollHeight) ||
      document.body.scrollHeight;
    let clientHeight =
      document.documentElement.clientHeight || window.innerHeight;
  };

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleOnScroll);
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  async setAllData() {
    this.setState({
      isMerchantLoading: true,
      isBankLoading: true,
    });

    let resMerchant = await getMerchant();
    let resBank = await getBank();
    const updateForm = { ...this.state.dataForm };
    updateForm["keywords"].elementConfig.options = await this.syncMerchant(
      resMerchant.data,
    );
    //  this.state.merchantList = resMerchant.data;
    updateForm["bank"].elementConfig.options = await this.syncBank(
      resBank.data,
    );
    updateForm["keywords"].value = "";
    updateForm["bank"].value = "";

    this.setState({
      dataForm: updateForm,
      isMerchantLoading: !resMerchant.data.length,
      isBankLoading: !resBank.data.length,
    });
  }

  async syncMerchant(res) {
    let categoryList = [];
    for (let merchant of res) {
      categoryList.push({
        id: merchant.merchantId,
        value: merchant.merchantName,
        displayValue: merchant.merchantName,
        logo: merchant.logoURL,
        location: merchant.location,
        termsAndCondition: merchant.termsAndCondition,
      });
    }
    return categoryList;
  }

  async syncBank(res) {
    let resList = [];
    for (let data of res) {
      resList.push({
        id: data.bankId,
        value: data.bankName,
        displayValue: data.bankName,
        logoURL: data.logoURL,
        cardTypes: data.cardTypes,
      });
    }
    return resList;
  }

  checkValidity(value, rules) {
    let isValid = true;
    if (rules.required && !moment.isMoment(value)) {
      isValid = value && value.trim() !== "" && isValid;
    }
    return isValid;
  }

  // inputHandleChange = (event, inputIdentity) => {
  //   let val = null;
  //   const updateForm = { ...this.state.dataForm };
  //   const updatedFormElement = {
  //     ...updateForm[inputIdentity],
  //   };
  //   let formatDate = "";
  //   if (
  //     inputIdentity === "startDate" ||
  //     inputIdentity === "endDate" ||
  //     inputIdentity === "validDate"
  //   ) {
  //     const parsedDate = moment(event._d, "YYYY-MM-DD");

  //     formatDate = parsedDate.format("YYYY-MM-DD");
  //   }

  //   switch (inputIdentity) {
  //     case "endDate":
  //       let dat_val = moment(event._d).format("YYYY-MM-DD");
  //       console.log("endDate", dat_val);
  //       //console.log("inputHandleChange", moment(event._d).format("DD-MM-YYYY"));
  //       updatedFormElement.value = event;
  //       updatedFormElement.dateValue = dat_val;
  //       break;
  //     case "startDate":
  //       let sdat_val = moment(event._d).format("YYYY-MM-DD");
  //       updatedFormElement.value = event;
  //       updatedFormElement.dateValue = sdat_val;
  //       break;
  //     default:
  //       updatedFormElement.value = event.target.value;
  //   }
  //   updatedFormElement.valid = this.checkValidity(
  //     updatedFormElement.value,
  //     updatedFormElement.validation,
  //   );
  //   updatedFormElement.touched = true;
  //   updateForm[inputIdentity] = updatedFormElement;
  //   let formIsValid = true;
  //   for (let inputIdentifier in updateForm) {
  //     formIsValid = updateForm[inputIdentifier].valid && formIsValid;
  //   }
  //   this.setState({ dataForm: updateForm, formIsValid: formIsValid });
  // };

  inputHandleChange = (event, inputIdentity) => {
    let val = null;
    const updateForm = {
      ...this.state.dataForm,
    };
    const updatedFormElement = {
      ...updateForm[inputIdentity],
    };
    //updatedFormElement.touched = true;
    updateForm[inputIdentity] = updatedFormElement;
    updatedFormElement.value = event;
    let formIsValid = true;
    for (let inputIdentifier in updateForm) {
      formIsValid = updateForm[inputIdentifier].valid && formIsValid;
    }
    this.setState({ dataForm: updateForm, formIsValid: formIsValid });
  };

  async clearAll() {
    const updateForm = { ...this.state.dataForm };
    for (let key in updateForm) {
      updateForm[key].value = "";
      updateForm[key].valid = false;
      updateForm[key].touched = false;
      if (key === "startDate" || key === "endDate" || key === "validDate") {
        updateForm[key].dateValue = "";
      }
      if (key === "startTime" || key === "endTime") {
        updateForm[key].timeValue = "";
      }
    }
    this.setState({ dataForm: updateForm });
  }

  async getAll() {
    this.setState({ isLoading: true });
    try {
      this.setState({ isLoading: false });
    } catch (error) {
      console.error("Error fetching data", error);
      this.setState({ isLoading: false });
    }
  }

  handleChange = (tabName) => {
    this.setState({
      selectBank: tabName,
    });
  };

  // async componentDidUpdate(prevProps, prevState) {
  //   if (prevState.selectBank !== this.state.selectBank) {
  //     this.setState({ newMerchantList: [] });
  //   }
  // }

  render() {
    const { tabJson, isLoading, dataForm, isBankLoading, isMerchantLoading } =
      this.state;
    const {} = this.props;

    return (
      <>
        <div className={"cco__page-header-wrapper"}>
          <PageHeader
            option={"d-flex justify-content-between"}
            isRefresh={false}
            isDate={false}
            isLoading={isLoading}
            // onClickRefresh={async () => {
            //   let res = await this.getUsers();
            // }}
            title={"SEO Mapping"}
          />
        </div>

        <div
          className={"d-flex flex-row justify-content-start gap-12 mt-3"}
          style={{ marginLeft: "24px", marginRight: "24px" }}
        >
          <Input
            elementConfig={dataForm.startDate.elementConfig}
            elementType={dataForm.startDate.elementType}
            required={dataForm.startDate.validation.required}
            isValid={!dataForm.startDate.valid}
            touched={dataForm.startDate.touched}
            value={dataForm.startDate.value}
            isShowRequired={false}
            size={"md"}
            margin={"mr-2"}
            label={dataForm.startDate.label}
            onChange={(event, date) => {
              this.inputHandleChange(event, dataForm.startDate.key);
              const updateForm = { ...this.state.dataForm };
              const updatedFormElement = { ...updateForm["startDate"] };

              if (event === null) {
                // DatePicker was cleared
                updatedFormElement.value = null;
                updatedFormElement.dateValue = "";
              } else {
                let sdat_val = moment(event._d).format("YYYY-MM-DD");
                updatedFormElement.value = event;
                updatedFormElement.dateValue = sdat_val;
              }

              updateForm["startDate"] = updatedFormElement;
              this.setState({ dataForm: updateForm });
            }}
          />

          <Input
            elementConfig={dataForm.endDate.elementConfig}
            elementType={dataForm.endDate.elementType}
            required={dataForm.endDate.validation.required}
            isValid={!dataForm.endDate.valid}
            touched={dataForm.endDate.touched}
            value={dataForm.endDate.value}
            isShowRequired={false}
            size={"md"}
            margin={""}
            label={dataForm.endDate.label}
            onChange={(event, date) => {
              this.inputHandleChange(event, dataForm.endDate.key);
              const updateForm = { ...this.state.dataForm };
              const updatedFormElement = { ...updateForm["endDate"] };

              if (event === null) {
                // DatePicker was cleared
                updatedFormElement.value = null;
                updatedFormElement.dateValue = "";
              } else {
                let sdat_val = moment(event._d).format("YYYY-MM-DD");
                updatedFormElement.value = event;
                updatedFormElement.dateValue = sdat_val;
              }

              updateForm["endDate"] = updatedFormElement;
              this.setState({ dataForm: updateForm });
            }}
          />
          <div
            className="d-flex flex-row justify-content-between align-items-center"
            style={{ width: "100%" }}
          >
            <div style={{ width: "100%" }}>
              <Input
                elementConfig={dataForm.bank.elementConfig}
                elementType={dataForm.bank.elementType}
                required={dataForm.bank.validation.required}
                isValid={!dataForm.bank.valid}
                touched={dataForm.bank.touched}
                value={dataForm.bank.value}
                defaultValue={null}
                label={dataForm.bank.label}
                isLoading={isBankLoading}
                isShowRequired={false}
                size={"lg"}
                margin={"ml-2"}
                // onKeyPress={this.handleKeyPress.bind(this)}
                // onClickAddTag={this.onClickAddLocation.bind(this)}
                changed={async (event) => {
                  this.inputHandleChange(event, dataForm.bank.key);
                  let bank = dataForm.bank.elementConfig.options.find(
                    (x) => x.value === event,
                  );
                  let updateList = [];
                  console.log({ bank });
                  if (bank) {
                    updateList.push(bank?.id);
                  }
                  await this.setState({ bankIdsList: updateList });
                  if (!bank) {
                    if (
                      this.state.categoryIdsList?.length > 0 ||
                      this.state.merchantIdsList?.length > 0
                    ) {
                      await this.onSearchFilter();
                    } else {
                      await this.getAll();
                    }
                  }
                }}
              />
            </div>

            <div style={{ width: "100%" }}>
              <Input
                elementConfig={dataForm.keywords.elementConfig}
                elementType={dataForm.keywords.elementType}
                required={dataForm.keywords.validation.required}
                isValid={!dataForm.keywords.valid}
                touched={dataForm.keywords.touched}
                value={dataForm.keywords.value}
                defaultValue={null}
                label={dataForm.keywords.label}
                isLoading={isMerchantLoading}
                isShowRequired={false}
                size={"lg"}
                margin={"ml-2"}
                // onKeyPress={this.handleKeyPress.bind(this)}
                // onClickAddTag={this.onClickAddLocation.bind(this)}
                changed={async (event) => {
                  this.inputHandleChange(event, dataForm.keywords.key);
                  let merchant = dataForm.keywords.elementConfig.options.find(
                    (x) => x.value === event,
                  );
                  let updateList = [];
                  if (merchant) {
                    updateList.push(merchant?.id);
                  }
                  await this.setState({ merchantIdsList: updateList });
                  if (!merchant) {
                    if (
                      this.state.bankIdsList?.length > 0 ||
                      this.state.categoryIdsList?.length > 0
                    ) {
                      await this.onSearchFilter();
                    } else {
                      await this.getAll();
                    }
                  }
                }}
              />
            </div>
          </div>
        </div>
        <div className={"cco__offerPlanner-body-wrapper"}>
          {!isLoading && (
            <>
              {tabJson?.length > 0 && (
                <div className={"cco__obw-tab"}>
                  <Tabs onChange={this.handleChange}>
                    <TabPane tab="SiteMap" key="1">
                      <SiteMap
                        startDate={dataForm.startDate.dateValue}
                        endDate={dataForm.endDate.dateValue}
                        bank={dataForm.bank.value}
                        merchant={dataForm.keywords.value}
                      />
                    </TabPane>
                  </Tabs>
                </div>
              )}
            </>
          )}

          {isLoading && (
            <div style={{ margin: "0 50%", opacity: 0.5 }}>
              <Spin size="large" spinning={isLoading} />
            </div>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
